
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ISskEmekliKaydi, SskEmekliCevap, sskEmekliKayitlari } from '@/plugins/uyap-plugin/uyap/SskEmekli';

@Component({})
export default class SskEmekliDetay extends Vue {
  @Prop() data!: SskEmekliCevap;

  get emekliKayitlari(): Array<ISskEmekliKaydi> {
    return sskEmekliKayitlari(this.data?.sorguSonucDVO);
  }

  get hasData() {
    return this.emekliKayitlari.length > 0;
  }

  // hataKodu 1 ("Aylık Ödenmemektedir") cevabında sorguSonucu false ama kayıt geliyor; bu hata değil, bilgi.
  get mesajTipi() {
    if (this.data.sorguSonucu)
      return 'success';
    return this.hasData ? 'info' : 'warning';
  }

  get kayitMesajlari(): Array<string> {
    const cokKayit = this.emekliKayitlari.length > 1;
    const mesajlar = this.emekliKayitlari
        .filter(kayit => this.kirp(kayit.hataMessage))
        .map(kayit => (cokKayit ? 'Tahsis No ' + this.kirp(kayit.tahno) + ': ' : '') + this.kirp(kayit.hataMessage))
        .filter(mesaj => mesaj != this.kirp(this.data.message));
    return mesajlar.filter((mesaj, index) => mesajlar.indexOf(mesaj) == index);
  }

  // tahno, sicno, banka/şube adları UYAP'tan boşluklu gelebiliyor.
  kirp(deger: any): string {
    return deger == null ? '' : String(deger).trim();
  }

  bankaSube(kayit: ISskEmekliKaydi) {
    return [this.kirp(kayit.bankaadi), this.kirp(kayit.subeadi)].filter(Boolean).join(' / ');
  }
}
